import ZariTable_Dropdown from './dropdown'
import ZariTable_Dropdown_Item from './item'
import ZariTable_Dropdown_Divider from './divider'

ZariTable_Dropdown.Item = ZariTable_Dropdown_Item
ZariTable_Dropdown.Divider = ZariTable_Dropdown_Divider

export default ZariTable_Dropdown
